import { Box, Flex, HStack, Text } from '@chakra-ui/react'
import { FC } from 'react'

const ExternoFooter: FC = () => (
  <Box
    borderTop="1px solid"
    borderColor="gray.200"
    bg="white"
    px={{ base: 5, md: 12 }}
    py={8}
    mt={12}
  >
    <Flex
      justify="space-between"
      align={{ base: 'flex-start', md: 'center' }}
      flexDir={{ base: 'column', md: 'row' }}
      gap={4}
    >
      <Box>
        <HStack spacing={1} mb={1}>
          <Text fontWeight="800" fontSize="15px" color="#0f5238">
            Leo Madeiras
          </Text>
          <Text fontWeight="400" fontSize="15px" color="gray.400">
            |
          </Text>
          <Text fontWeight="700" fontSize="15px" color="gray.700">
            SCL
          </Text>
        </HStack>
        <Text fontSize="13px" color="gray.500" maxW="280px">
          © {new Date().getFullYear()} Leo Madeiras. Tecnologia para marcenaria.
        </Text>
      </Box>
      <HStack spacing={6}>
        {['Privacidade', 'Termos', 'Ajuda'].map(label => (
          <Text
            key={label}
            fontSize="13px"
            color="gray.500"
            fontWeight="500"
            cursor="default"
            _hover={{ color: '#0f5238' }}
            transition="color 0.15s"
          >
            {label}
          </Text>
        ))}
      </HStack>
    </Flex>
  </Box>
)

export default ExternoFooter
